import styled from "styled-components";
import AskRemoveModal from "./AskRemoveModal";
import { useState } from "react";
import palette from "../../lib/styles/palette";

const ActionButtonsBlock = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const ActionButton = styled.button`
    padding: 0.5rem 0.5rem;
    border-radius: 4px;
    border: none;
    background-color: ${palette.orange};
    color: #fff;
    font-size: 0.95rem;
    font-weight: 550;
    border: 1px solid transparent;
    &:hover {
        background: #fff;
        color: ${palette.orange};
        border: 1px solid ${palette.orange};
        cursor: pointer;
        transition: 0.3s;
    }
    & + & {
        margin-left: 0.25rem;
    }
`;

const ActionButtons = ({ onEdit, onRemove }) => {
    const [modal, setModal] = useState(false);
    const onRemoveClick = () => {
        setModal(true);
    }
    const onCancel = () => {
        setModal(false);
    }
    const onConfirm = () => {
        setModal(true);
        onRemove();
    }

    return (
        <>
            <ActionButtonsBlock>
                <ActionButton onClick={onEdit}>Edit</ActionButton>
                <ActionButton onClick={onRemoveClick}>Delete</ActionButton>
            </ActionButtonsBlock>
            <AskRemoveModal visible={modal} onConfirm={onConfirm} onCancel={onCancel} />
        </>
    );
};

export default ActionButtons;